import { render, staticRenderFns } from "./ContactDetailMixin.vue?vue&type=template&id=295d3f6e&"
import script from "./ContactDetailMixin.vue?vue&type=script&lang=js&"
export * from "./ContactDetailMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports